import { useEffect, useState } from "react";
import axios from "axios";
import { API } from "../../lib/site";

export const Testimonials = () => {
  const [items, setItems] = useState([]);
  useEffect(() => {
    axios.get(`${API}/depoimentos`).then((r) => setItems(r.data)).catch(() => setItems([]));
  }, []);
  if (!items.length) return null;
  return (
    <section className="py-24 sm:py-32" data-testid="testimonials-section">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <p className="text-xs font-semibold uppercase tracking-[0.25em] text-[#218FFF]">Depoimentos</p>
        <h2 className="mt-3 text-3xl font-extrabold uppercase tracking-tight text-[#15579A] sm:text-4xl">Quem já avançou</h2>
        <div className="mt-12 grid gap-5 md:grid-cols-3">
          {items.map((d) => (
            <figure key={d.id} className="flex flex-col justify-between rounded-[24px] border border-[#C8D7E4] bg-white p-8" data-testid={`testimonial-card-${d.id}`}>
              <blockquote className="font-serif text-xl italic leading-relaxed text-[#15579A]">“{d.texto}”</blockquote>
              <figcaption className="mt-8">
                <p className="font-bold text-[#196ABC]">{d.nome}</p>
                {d.detalhe && <p className="text-sm text-[#15579A]/70">{d.detalhe}</p>}
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
};
